import InterestUri from '../../Enum/InterestUri';
import useGetEngine from '../UseGetEngine';

const isAllowed = (section: InterestUri): boolean => {
    const { isProductPropertiesOnly } = useGetEngine();

    if (!isProductPropertiesOnly()) {
        return true;
    }

    return [
        InterestUri.PropertiesPerLabel,
        InterestUri.PropertiesPerProperty,
        InterestUri.InterestNews,
        InterestUri.PropertiesNews,
    ].includes(section);
};

export default isAllowed;
